import { $ } from '@/libs/jquery/index'
import { routes } from '@/libs/routes/index'
import { LeadsForm, leadsRemoteFormSelector } from '@/views/application/leads/shared/remote_form/index'

export class LeadsRemoteForm {
  private selectors: ISelectors = {
    base: leadsRemoteFormSelector,
  }

  private base: JQuery | null = null

  public constructor() {
    this.base = $(this.selectors.base)

    if (this.base.length) {
      this.init()
    }
  }

  private init(): void {
    const $body = $('body')
    const company = $body.data('company')
    const product = $body.data('product')
    const form = new LeadsForm(this.selectors.base, routes.new_lead_path({company, product}))
  }
}
